import React, { useState, useEffect,useContext } from "react";
import { ShiftService } from "../../api/ShiftService";
import { useRouteMatch, useHistory } from "react-router-dom";
import moment from "moment-timezone";
import { AuthService } from "../../api/AuthService";
import { ErrorMessageProps } from "../../interfacesProps/ErrorMessageProps";
import { RBCardView } from "../../components/RBCardView";
import { Spacing, Colors } from "../../theme/Theme";
import { orderBy, map } from "lodash";
import { ColumnStyle, skillTextStyle } from "../../theme/ComponentTheme";
import {
  Typography,
  FormControl,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
  FormControlLabel,
} from "@material-ui/core";
import {
  RBTextField,
  RBMoneyAmountTextField,
} from "../../components/RBTextField";
import { RBDateTimePicker } from "../../components/RBDateTimePicker";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { RBEmptyBlock } from "../../components/RBEmptyBlock";
import { ErrorMessages, Claims, EmptyString, roleNameEnum, ApprovalModeEnum } from "../../util/Common";
import { formatWorkerType } from "../../util/FormattingService";
import { workerTypeEnum, SkillType } from "../../util/Enumeration";
import { SkillResponseDto } from "../../dtos/Skill.dto";
import { PharmacyService } from "../../api/PharmacyService";
import { ObjectLiteral } from "../../interfacesProps/ObjectLiteralProps";
import { LabelText } from "../../util/TextConstant";
import {
  detailKmAllowanceIcon,
  detailAccomodationAllowanceIcon,
} from "../../util/Icons";
import { LoadingIndicator } from "../../components/LoadingIndicator";
import { RBButton, RBButtonType } from "../../components/RBButton";
import { RBContext } from '../../components/RBContext';
import { AccountInfoContext } from '../../components/AccountInfoContext';

import NotificationService, {
  NotificationServiceTopic,
} from "../../api/NotificationService";
import { RBAlert, RBErrorAlert } from "../../components/RBAlert";

export const EditDentalJobPage = (props:any) => {
  const { primaryColor,secondaryColor,industryMode } = useContext(RBContext);
  const { fetchPharmacy } = useContext(AccountInfoContext);
  const [isPageLoading, setIsPageLoading] = useState(true);
  const [pharmacy, setPharmacy] = useState<any>(EmptyString);
  const [originalJobData, setOriginalJobData] = useState<ObjectLiteral>({});
  const [selectedWorkerType, setSelectedWorkerType] = useState(EmptyString);
  const [jobTitle, setJobTitle] = useState(EmptyString);
  const [workerTypes, setWorkerTypes] = useState([]);
  const [jobCategories, setJobCategories] = useState<any>([]);
  const [selectedJobCategory, setSelectedJobCategory] = useState<any>(EmptyString);

  const [wage, setWage] = useState<string>("0");
  const [wageInvalidErrorText, setWageInvalidErrorText] = useState(EmptyString);
  const [workerType, setWorkerType] = useState<any>("pharmacist");
  const [workerTypesAndRates, setWorkerTypesAndRates] = useState<ObjectLiteral>([]);
  // update button is loading or not
  const [loading, setIsLoading] = useState(false);

  const [isEdited, setIsEdited] = useState(false);
  const match = useRouteMatch<{ jobId: string }>();
  const history = useHistory();
  const [submitErrorMessage, setSubmitErrorMessage] = useState<
    ErrorMessageProps
  >();
  const [isCreateShiftSubmitInfo,setIsCreateShiftSubmitInfo] = useState(false)
  const [createShiftSubmitInfo,setCreateShiftSubmitInfo] = useState <any>({ title: "", message: "", buttons: [] })

  const [rateObject, setRateObject] = useState({
    hourlyRate: '0',
    hourlyRateDisplayValue: '0.00',
    isRateValid: true
  });
  const [comments, setComments] = useState('');
  const [dateObject, setDateObject] = useState<any>({
    estStartDate: moment().add(1, 'days').hours(12),
    estEndDate: null,
  });
  const [allowOtherProvince, setAllowOtherProvince] = useState(false);

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [pharmacyTimezoneOffset, setpharmacyTimezoneOffset] = useState<any>('');
  const [pharmacyTimezone, setpharmacyTimezone] = useState('');
  const [skillsByType, setSkillsByType] = useState<any>({})
  const [selectedSkillsByType, setSelectedSkillsByType] = useState<any>({})
  const [requiredFlagsByType, setRequiredFlagsByType] = useState<any>({});
  const [allSkills, setAllSkills] = useState<any>({});
  const[savedSkillOptionsByType, setSavedSkillOptionsByType] = useState<any>({});
  const [roleName, _] = useState<string>(AuthService.getRoleName());
    const [currentPharmacy, setCurrentPharmacy] = useState<any>(null);

  const getDateTime = (date: any) => {
    let currentDate = moment(date).tz(pharmacyTimezone)
    let year = currentDate.format('YYYY')
    let month = currentDate.format('MM')
    let day = currentDate.format('DD')
    let hour = currentDate.format('HH')
    let minute = currentDate.format('mm')
    let second = currentDate.format('ss')
    let convertedDate = moment(year + '-' + month + '-' + day + ' ' + hour + ':' + minute + ':' + second);
    return convertedDate;
  }

  const convertDatetoLocationsTimezone = (currentDate:any,offsetString:any) =>{
    let year = currentDate.format('YYYY')
    let month = currentDate.format('MM')
    let day = currentDate.format('DD')
    let convertedDate = moment(moment(year + '-' + month + '-' + day).format('YYYY-MM-DDTHH:mm:ss') + offsetString);
    return convertedDate

  }

  const convertOffsetToString = (offset: any) => {
    let value = '';
    const absOffset = Math.abs(offset);
    const hr = absOffset / 60;
    const min = absOffset % 60;
    if (offset < 0) {
      value = value + '-';
    }
    else {
      value = value + '-';
    }
    if (hr < 10) {
      value = value + '0' + hr;
    }
    else {
      value = value + hr;
    }
    if (min < 10) {
      value = value + ':0' + min;
    }
    else {
      value = value + ':' + min;
    }
    return value;
  }
  
  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsPageLoading(true);
        const jobDetailData = await ShiftService.getJobtDetailByJobId(
          match.params.jobId
        );

        setOriginalJobData(jobDetailData);
        const { locationSkillSets, jobSkillSets } = jobDetailData?.pharmacy?.network.skillSet;
        const skillSet = [...locationSkillSets, ...jobSkillSets]
        let skills = await PharmacyService.fetchSkills(skillSet, industryMode);
        const pharmacyDetails = await fetchPharmacy(jobDetailData.pharmacy.id);
        const allSkills = {
          data: skills.data.reduce((acc: Record<string, any[]>, skill: any) => {
            const type = skill.type;

            if (skillSet.includes(type)) {
              if (!acc[type]) acc[type] = [];
              acc[type].push(skill);
            }

            return acc;
          }, {})
        };
        setAllSkills(allSkills.data)
        console.log('allSkills', allSkills);
        const skillsByType: any = {};
        const selectedSkillsByType: any = {};
        const requiredFlagsByType: any = {};
        const savedSkillOptionsByType: any = {};
        const pharmacySkillIds = (pharmacyDetails?.skills || []).map((s:any) => s.id);


        for (const type in allSkills.data) {
          if (allSkills.data.hasOwnProperty(type)) {
            const skillsArray = allSkills.data[type];
            skillsByType[type] = [];
            selectedSkillsByType[type] = [];
            requiredFlagsByType[type] = false;
             savedSkillOptionsByType[type] = []

            for (const skill of skillsArray) {
              // ✅ Include skill if it's either a match or has no pharmacistType
              const isRelevantPharmacistType =
                !skill.pharmacistType || skill.pharmacistType === jobDetailData.pharmacistType;

              if (isRelevantPharmacistType) {
                skillsByType[type].push(skill);

                 if (
                  locationSkillSets.includes(type) &&
                  pharmacySkillIds.includes(skill.id)
                ) {
                  savedSkillOptionsByType[type].push(skill);
                }


                const isSelected = jobDetailData.skills.find((s: any) => s.id === skill.id);
                if (isSelected) {
                  selectedSkillsByType[type].push(skill);
                  if (isSelected.required) {
                    requiredFlagsByType[type] = true;
                  }
                }
              }
            }
          }
        }
        setSavedSkillOptionsByType(savedSkillOptionsByType)
        console.log("selectedSkillsByType", selectedSkillsByType)
        setSkillsByType(skillsByType)
        setSelectedSkillsByType(selectedSkillsByType)
        setRequiredFlagsByType(requiredFlagsByType)
        const jobCategories = await AuthService.getRBDentalJobCategory();
        const workerTypes = await AuthService.getAllWorkers(industryMode);
        console.log('workerTypesAndRates2', workerTypesAndRates)
        setPharmacy(jobDetailData.pharmacy)
        setSelectedWorkerType(jobDetailData.pharmacistType);
        setSelectedJobCategory(jobDetailData.jobCategory.name)
        setAllowOtherProvince(jobDetailData.allowOtherProvince)
        setComments(jobDetailData.comment)
        setJobTitle(jobDetailData.jobTitle)

        setRateObject({
            hourlyRate: (jobDetailData.estHourlyRate / 100).toString(),
            hourlyRateDisplayValue: (jobDetailData.estHourlyRate / 100).toFixed(2),
            isRateValid: true,
          })
        setWage((jobDetailData.estHourlyRate / 100).toFixed(2))
        setDateObject({
            estStartDate: jobDetailData.estStartDate,
            estEndDate: jobDetailData.estEndDate,
          });

        setJobCategories(jobCategories);
        setWorkerTypes(workerTypes)

        setpharmacyTimezoneOffset(moment().tz(pharmacyDetails.address.timezone).utcOffset());
        setpharmacyTimezone(pharmacyDetails.address.timezone);

        setWorkerType(jobDetailData.pharmacistType);
      
        setWage((jobDetailData.estHourlyRate / 100).toFixed(2));
        setIsPageLoading(false);
      } catch (err) {
        setSubmitErrorMessage(err.response ? err.response.data : err.message);
      } finally {
      }
    };

    fetchData();
  }, [match.params.jobId]);

    useEffect(() => {
    const fetchWorkerTypeMinRates = async () => {
      try{
       const workerTypesAndRates = await AuthService.getActiveWorkerTypeMinimumRate(workerType);
        console.log('workerTypesAndRates - 11', workerTypesAndRates)
        setWorkerTypesAndRates(workerTypesAndRates);
      }
      catch(err){
        setSubmitErrorMessage(err.response ? err.response.data : err.message);
      }
    }
    fetchWorkerTypeMinRates()
    
  }, [workerType])

  useEffect(() => {
    isWageValid();
  }, [workerTypesAndRates,wage]);
  useEffect(() => {
    if (Object.keys(originalJobData).length > 0) {
      checkIsJobEdited();
    }
  }, [
    wage,
    comments,
    rateObject,
    dateObject,
    allowOtherProvince,
    jobTitle,
    selectedJobCategory,
    selectedSkillsByType,
    requiredFlagsByType
  ]);

  const checkIsJobEdited = () => {
    const originalHourlyRate = (originalJobData.estHourlyRate / 100).toFixed(2);
    const originalJobTitle = originalJobData.jobTitle;

    let hasSkillChanges = false;

    const { locationSkillSets, jobSkillSets } = originalJobData.pharmacy.network.skillSet;
    const allSkillTypes = [...locationSkillSets, ...jobSkillSets];

    for (const type of allSkillTypes) {
      const originalSkills = originalJobData.skills.filter((skill: any) => skill.type === type);
      const selectedSkills = selectedSkillsByType[type] || [];

      const originalRequired = originalSkills.some((s: any) => s.required);
      const currentRequired = requiredFlagsByType[type] || false;

      const originalIds = JSON.stringify(map(orderBy(originalSkills, 'id'), 'id'));
      const selectedIds = JSON.stringify(map(orderBy(selectedSkills, 'id'), 'id'));

      console.log('originalIds', originalIds);
      console.log('originalIds selectedIds', selectedIds);

      if (originalIds !== selectedIds || originalRequired !== currentRequired) {
        hasSkillChanges = true;
        break;
      }
    }
        
    const originalComment = originalJobData.comment;
    const originalEstStartDate = originalJobData.estStartDate;

    const originalEstEndDate = originalJobData.estEndDate;
    const isEdited2 =
      originalJobTitle !== jobTitle ||
      comments !== originalComment ||
      selectedJobCategory !== originalJobData.jobCategory.name ||
      allowOtherProvince !== originalJobData.allowOtherProvince ||
      wage !== originalHourlyRate ||
      selectedWorkerType !== originalJobData.pharmacistType ||
      dateObject.estStartDate !== originalEstStartDate ||
      dateObject.estEndDate !== originalEstEndDate ||
      hasSkillChanges;

    console.log("originalJobTitle",originalEstStartDate)
    console.log("originalJobTitle1",dateObject.estStartDate)

    setIsEdited(isEdited2);
    return isEdited2;
  };
  const renderJobTime = () => {
    return (
      <>
        {/* {multipleShifts.map((shift) => ( */}
            <div
              style={{
                ...ColumnStyle, alignItems: "center"
              }}
            >
               <Typography style={{ display: "flex", flex: 1 }}>
               Est. Start Date
              </Typography>
              <RBEmptyBlock />
              <FormControl
                variant="outlined"
                size={"small"}
                style={{ display: "flex", flex: 1 }}
                >
                <DatePicker
                    selected={moment(dateObject.estStartDate).toDate()}
                    onChange={(date) => {
                    const offsetString = convertOffsetToString(pharmacyTimezoneOffset);
                    let currentDate = moment(date)
                    let year = currentDate.format('YYYY')
                    let month = currentDate.format('MM')
                    let day = currentDate.format('DD')


                    let convertedDate = moment(moment(year + '-' + month + '-' + day).format('YYYY-MM-DDTHH:mm:ss') + offsetString);
                    setDateObject({
                        estStartDate: convertedDate.hour(12),
                        estEndDate:dateObject.estEndDate,
                    });
                    }}
                    
                    minDate={tomorrow}
                    dateFormat="MMM do, yyyy"
                    customInput={
                    <input
                        style={{
                        paddingTop: Spacing.medium,
                        paddingBottom: Spacing.medium,
                        paddingRight: "30%",
                        borderRadius:5,
                        borderColor:"rgb(220 220 220)",
                        width: 409,
                        fontSize:16,
                        paddingLeft:10
                        }}
                        key={`dateTime`}
                    />
                    }
                    withPortal
                />
              </FormControl>
            </div>
            <div
              style={{
                ...ColumnStyle, alignItems: "center"
              }}
            >
               <Typography style={{ display: "flex", flex: 1 }}>
               Est. End Date
              </Typography>
              <RBEmptyBlock />
              <FormControl
                variant="outlined"
                size={"small"}
                style={{ display: "flex", flex: 1 }}
                >
              <DatePicker
                selected={dateObject.estEndDate !== null ? moment(dateObject.estEndDate).toDate(): null}
                onChange={(date) => {
                  const offsetString = convertOffsetToString(pharmacyTimezoneOffset);
                  let currentDate = moment(date)
                  let year = currentDate.format('YYYY')
                  let month = currentDate.format('MM')
                  let day = currentDate.format('DD')


                  let convertedDate = moment(moment(year + '-' + month + '-' + day).format('YYYY-MM-DDTHH:mm:ss') + offsetString);
                  setDateObject({
                    estStartDate: dateObject.estStartDate,
                    estEndDate: convertedDate.hour(12)
                  });
                }}
                minDate={moment(dateObject.estStartDate).toDate()}
                dateFormat="MMM do, yyyy"
                customInput={
                  <input
                    style={{
                      paddingTop: Spacing.medium,
                      paddingBottom: Spacing.medium,
                      paddingRight:"45%",
                      borderRadius:5,
                      borderColor:"rgb(220 220 220)",
                      width: 409,
                      fontSize:16,
                      paddingLeft:10
                    }}
                    key={`dateTime`}
                  />
                }
                placeholderText="Optional"
                withPortal
              />
             </FormControl>
            </div>
        {/* ))} */}
      </>
    );
  };

  const renderPharmacyName = () => {
    const pharmacyName = pharmacy ? pharmacy.name : 'N/A';
    return (
      <Typography variant="h6" style={{ textAlign: "left" }}>
        {pharmacyName}
      </Typography>
    );
  };


  const renderTitle = () => {
    return (
      <>
        <div style={{ ...ColumnStyle, alignItems: "center" ,paddingTop: Spacing.medium}}>
          <Typography style={{ display: "flex", flex: 1 }}>
            Title
          </Typography>
          <RBEmptyBlock />
          <FormControl
            variant="outlined"
            size={"small"}
            style={{ display: "flex", flex: 1 }}
          >
            <RBTextField
              className="custom-focused-input"
              style={{
                display: "flex",
                flex: 1,
                maxHeight: "40px",
                borderColor:"black"
              }}
              
              placeholder={"Optional"}
              value={jobTitle}
              onChange={(event) => setJobTitle(event.target.value)}
            />
          </FormControl>
        </div>
      </>
    );
  };

  const  renderJobType = () => {
    return (
      <div style={{ ...ColumnStyle, alignItems: "center" }}>
        <Typography style={{ display: "flex", flex: 1 }}>
          Job Type
        </Typography>
        <RBEmptyBlock />
        <FormControl
          variant="outlined"
          size={"small"}
          style={{ display: "flex", flex: 1 }}
        >
         <Select
          value={selectedJobCategory}
          displayEmpty
          renderValue={selectedJobCategory !== "" ? undefined : () => "Select"}
          onChange={(event) => setSelectedJobCategory(event.target.value)}>
          {jobCategories.map((value:any) => (
            <MenuItem value={value.name} key={value.name}>
              {value.name}
            </MenuItem>
          ))}
        </Select>
        </FormControl>
      </div>
    );
  };

  const updateWorkerType = async (event: any) => {
     const workerTypesAndRates = await AuthService.getActiveWorkerTypeMinimumRate(event.target.value);
     const { jobSkillSets } = originalJobData.pharmacy.network.skillSet;

    // Filter out only shift skill entries
    const updatedSkillsByType = Object.fromEntries(
      Object.entries(selectedSkillsByType).filter(
        ([key]) => !jobSkillSets.includes(key)
      )
    );

    setWorkerType(event.target.value);
    setWage("0")
    setRateObject({
      hourlyRate: '0',
      hourlyRateDisplayValue: '0.00',
      isRateValid: true,
    });
    setWorkerTypesAndRates(workerTypesAndRates);
    setSelectedSkillsByType(updatedSkillsByType)
  };

  const renderWorkerType = () => {
    return (
      <div style={{ ...ColumnStyle, alignItems: "center" }}>
        <Typography style={{ display: "flex", flex: 1 }}>
          Worker Type
        </Typography>
        <RBEmptyBlock />
        <FormControl
          variant="outlined"
          size={"small"}
          style={{ display: "flex", flex: 1 }}
        >
         <Select
          value={workerType}
          displayEmpty
          renderValue={workerType !== "" ? undefined : () => "Select"}
          onChange={updateWorkerType}>
          {workerTypes.map((value:any) => (
            <MenuItem value={value.workerType} key={value.workerType}>
              {value.displayName}
            </MenuItem>
          ))}
        </Select>
        </FormControl>
      </div>
    );
  };

  const handleShiftSkillChange = (type: string, selectedIds: string[]) => {
     if (!selectedIds.length || selectedIds[0] === "") {
      setSelectedSkillsByType((prevState: any) => ({
        ...prevState,
        [type]: [],
      }));
      return;
    }

    const selectedSkills = (allSkills[type] || []).filter(
      (skill: any) => selectedIds.includes(skill.id)
    );
  
    setSelectedSkillsByType((prevState: any) => ({
      ...prevState,
      [type]: selectedSkills,
    }));
  };
  
    const capitalize = (str:any) => {
      return str.charAt(0).toUpperCase() + str.slice(1);
    }
    const renderShiftSkills = () => {
      const { jobSkillSets,isWorkerTypeDependent,jobMultiSelects } = originalJobData.pharmacy.network.skillSet;
  
      return jobSkillSets.map((type: string) => {
        const selectedSkillIds = (selectedSkillsByType[type] || []).map((s: any) => s.id);
  
        // Ensure selected skills are included even if they don’t match pharmacistType
        const options = (allSkills[type] || [])
          .filter((s: any, index: number, self: any[]) =>
            index === self.findIndex((t) => t.id === s.id)
          )
          .filter((s: any) =>
            !isWorkerTypeDependent ||
            s.pharmacistType === workerType ||
            selectedSkillIds.includes(s.id)
          );
        const isMultiSelect = jobMultiSelects.includes(type);
        return (
          <div key={type}>
            <div style={{ ...ColumnStyle, alignItems: "center" }}>
              <Typography style={{ display: "flex", flex: 1 }}>
                {capitalize(type)} {type === 'specialization' ? 'Skills' : ''}
              </Typography>
              <RBEmptyBlock />
              <FormControl
                variant="outlined"
                size="small"
                style={{ display: "flex", flex: 1 }}
              >
                <Select
                  multiple={isMultiSelect}
                  value={
                    isMultiSelect
                      ? selectedSkillIds
                      : selectedSkillIds.length > 0
                        ? selectedSkillIds[0]
                        : ""
                  }
                  onChange={(event) => {
                    const value = event.target.value;
                    handleShiftSkillChange(
                      type,
                      isMultiSelect ? (value as string[]) : [value as string]
                    );
                  }}
                  displayEmpty
                  renderValue={(selected) => {
                    const selectedArray = isMultiSelect
                      ? (selected as string[])
                      : [selected as string];

                    if (!selectedArray.length || !selectedArray[0]) {
                      return "Add Skills";
                    }
                    return (
                      <div style={{ display: "flex", flexWrap: "wrap" }}>
                        {selectedArray.map((id) => {
                          const skill: any = options.find((s: any) => s.id === id);
                          return (
                            <div key={id} style={{ ...skillTextStyle }}>
                              {skill?.name || id}
                            </div>
                          );
                        })}
                      </div>
                    );
                  }}
                >
                  {!isMultiSelect && (
                    <MenuItem value="">
                      Select
                    </MenuItem>
                  )}
                  {options.map((skill: any) => (
                    <MenuItem key={skill.id} value={skill.id}>
                      {isMultiSelect && (
                        <Checkbox
                          checked={selectedSkillIds.includes(skill.id)}
                          style={{
                            color: selectedSkillIds.includes(skill.id)
                              ? secondaryColor
                              : Colors.darkGrey,
                          }}
                        />
                      )}
                      <ListItemText primary={skill.name} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>

            <div
              style={{
                ...ColumnStyle,
                alignItems: "center",
                marginBottom: Spacing.small,
              }}
            >
              <Typography style={{ display: "flex", flex: 1 }}></Typography>
              <RBEmptyBlock />
              <div
                style={{
                  display: "flex",
                  flex: 1,
                  flexDirection: "column",
                  fontSize: 12,
                  textAlign: "start",
                }}
              >
                *Select only mandatory skills
              </div>
            </div>
          </div>
        );
      });
    };
    const renderLocationSkills = () => {
       const { locationSkillSets,locationMultiSelects } = originalJobData.pharmacy.network.skillSet;
    
      return locationSkillSets.map((type:any) => {
       const selected = selectedSkillsByType[type] || [];
      const required = requiredFlagsByType[type];
      const softwareRequiredColor = required
        ? secondaryColor
        : Colors.darkGrey;
        const isMultiSelect = locationMultiSelects.includes(type);
        const options = savedSkillOptionsByType[type] || [];

        const selectedIds = isMultiSelect
          ? selected.map((s: any) => s.id)
          : selected.length > 0 ? selected[0].id : "";
        return (
          <>
            {!isMultiSelect ?
              <div style={{ ...ColumnStyle, alignItems: "center" }}>
                <Typography style={{ display: "flex", flex: 1 }}>
                  {capitalize(type)}
                </Typography>
                <RBEmptyBlock />
                <FormControlLabel
                  style={{
                    display: "flex",
                    flex: 1,
                    color: softwareRequiredColor,
                  }}
                  control={
                    <Checkbox
                      checked={required}
                      style={{
                        color: softwareRequiredColor,
                      }}
                      onChange={() =>
                        setRequiredFlagsByType((prev: any) => ({
                          ...prev,
                          [type]: !prev?.[type],
                        }))
                      }
                    />
                  }
                  label={<Typography> {selected.length > 0
                    ? selected.map((s: any) => s.name).join(', ')
                    : 'None Selected'}</Typography>}
                />
              </div>
              :
              <div style={{ ...ColumnStyle, alignItems: "center", marginTop: -Spacing.medium }}>
                <Typography style={{ display: "flex", flex: 1 }}>
                  {capitalize(type)}
                </Typography>
                <RBEmptyBlock />
                <FormControl variant="outlined" size="small" style={{ display: "flex", flex: 1 }}>
                  <Select
                    multiple={isMultiSelect}
                    value={selectedIds}
                    onChange={(event) => {
                      const value = event.target.value;
                      const selectedIdsArray: any = isMultiSelect ? value : [value];
                      const selectedSkills = options.filter((s: any) =>
                        selectedIdsArray.includes(s.id)
                      );
                      setSelectedSkillsByType((prevState: any) => ({
                        ...prevState,
                        [type]: selectedSkills,
                      }));
                      setRequiredFlagsByType((prevState: any) => ({
                        ...prevState,
                        [type]: selectedSkills.length > 0, // true if skills selected, false if none
                      }));
                    }}
                    displayEmpty
                    renderValue={(selected) => {
                      const selectedArray: any = isMultiSelect ? selected : [selected];
                      const selectedNames = options
                        .filter((s: any) => selectedArray.includes(s.id))
                        .map((s: any) => s.name);
                      return selectedNames.length > 0 ? selectedNames.join(', ') : 'Add Skills';
                    }}
                  >
                    {options.map((skill: any) => (
                      <MenuItem key={skill.id} value={skill.id}>
                        {isMultiSelect && (
                          <Checkbox
                            checked={selectedIds.includes(skill.id)}
                            style={{
                              color: selectedIds.includes(skill.id)
                                ? secondaryColor
                                : Colors.darkGrey,
                            }}
                          />
                        )}
                        <ListItemText primary={skill.name} />
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>
            }
            <div
              style={{
                ...ColumnStyle,
                alignItems: "center",
                marginTop: Spacing.smallest,
              }}
            >
              <Typography style={{ display: "flex", flex: 1 }}></Typography>
              <RBEmptyBlock />
              <div
                style={{
                  display: "flex",
                  flex: 1,
                  flexDirection: "column",
                  fontSize: 12,
                  textAlign: "start",
                }}
              >
               *Select if {type} is mandatory
              </div>
            </div>
          </>
        )
         });
      }
  
    const renderPharmacySpecific = () => {
      return (
        <>
          {renderLocationSkills()}
        
      </>
    );
  };

  const isRateValid = () => {
    const lowerBound = getMinimumHourlyRate();
    const rateAmount = parseFloat(wage);
    const result = rateAmount >= lowerBound && isFinite(rateAmount);
    setRateObject({
      ...rateObject,
      isRateValid: result,
    });
    return result;
  };
  const renderWage = () => {
    return (
      <>
        <div
          style={{
            ...ColumnStyle,
            alignItems: "center",
            paddingBottom: Spacing.smallest,
          }}
        >
          <Typography style={{ display: "flex", flex: 1 }}>
          Est. Hourly Rate
          </Typography>
          <RBEmptyBlock />
          <RBMoneyAmountTextField
            name="currency"
            value={wage}
            onChange={(event) =>
                {
                    setWage( event.target.value == "0.00" ? "0" : event.target.value)
                    isRateValid();
                }
            }
            error={wageInvalidErrorText.length > 0}
            errorText={wageInvalidErrorText}
          />
        </div>
       


      </>
    );
  };

  const renderJobDesc = () => {
    return (
      <>
        <div style={{ ...ColumnStyle, alignItems: "center" }}>
          <Typography style={{ display: "flex", flex: 1 }}>Job Description*</Typography>
        </div>
        <RBTextField
          style={{
            display: "flex",
            flex: 1,
            paddingTop: Spacing.small,
            paddingBottom: Spacing.small,
          }}
          placeholder={"*Please include a description and important details about the job."}
          value={comments}
          onChange={(event) => setComments(event.target.value )}
          multiline
          rows={3}
          rowsMax={8}
        />
         <div
          style={{
            ...ColumnStyle,
            alignItems: "center",
            paddingBottom: Spacing.smallest,
          }}
        >
          <Typography style={{ display: "flex", flex: 1 }}>
          Allow applicants from other provinces?
          </Typography>
          <RBEmptyBlock />
          <FormControlLabel
              style={{
                display: "flex",
                flex: 1,
              }}
              control={
                <Checkbox
                  checked={allowOtherProvince}
                  style={{
                    color: allowOtherProvince
                      ? secondaryColor
                      : Colors.darkGrey,
                  }}
                  onChange={() =>
                    setAllowOtherProvince(!allowOtherProvince)
                  }
                />
              }
              label={EmptyString}
            />
        </div>
      </>
    );
  };
  const getMinimumHourlyRate = () => {
    if (workerTypesAndRates && workerTypesAndRates.workerType === workerType) {
            return (workerTypesAndRates.jobMinimumRate || 0) / 100;
          }

          return 100;
  };
  const isWageValid = () => {
    const getMinimumWage = () => {
      
        if (workerTypesAndRates && workerTypesAndRates.workerType === workerType) {
            return (workerTypesAndRates.jobMinimumRate || 0) / 100;
          }

          return 100;
      };
      const lowerBound = getMinimumWage();
  
      setWageInvalidErrorText(
        Number(wage) >= lowerBound
          ? EmptyString
          : `The minimum rate is $${lowerBound.toFixed(2)}`
      );
  };

 
  const isFormValid = () => {
    const isEstDatesValid = dateObject.estEndDate
      ? moment(dateObject.estStartDate).diff(dateObject.estEndDate) < 0
      : true;
    return (
      rateObject.isRateValid &&
      selectedWorkerType !== '' &&
      selectedJobCategory !== '' &&
      isEstDatesValid
    );
  };
  const onUpdateJob = async () => {
    const originalEstStartDate = originalJobData.estStartDate;

    const originalEstEndDate = originalJobData.estEndDate;

    
    if(originalEstStartDate === dateObject.estStartDate)
    {
      const offsetString = convertOffsetToString(pharmacyTimezoneOffset)
      let convertedDate = convertDatetoLocationsTimezone(moment(dateObject.estStartDate),offsetString); 
      dateObject.estStartDate = convertedDate.hours(12);
    }
    if(originalEstEndDate !== null && originalEstEndDate === dateObject.estEndDate){
      const offsetString = convertOffsetToString(pharmacyTimezoneOffset)
      let convertedDate = convertDatetoLocationsTimezone(moment(dateObject.estEndDate),offsetString); 
      dateObject.estEndDate = convertedDate.hours(12);
    }
    if (!isFormValid()) {
        setCreateShiftSubmitInfo({
            title: "Unable to update Job",
            message: "Please double check the dates",
            buttons: [
    
              <RBButton
                buttonBackgroundColor={primaryColor}
                key={"Discard"}
                onClick={() => {
                  setIsCreateShiftSubmitInfo(false)
                  history.push("/Job/list")
                }}
                color="primary"
                text="Ok"
              />,
            ],
          })
          setIsCreateShiftSubmitInfo(true)

        return;
    }
    if (!isWageValid) {
      return;
    }
    setIsLoading(true);
    setIsSubmitting(true);
    // Build the skills list and add the software to the end
    const skills:any = [];

    Object.keys(selectedSkillsByType).forEach(type => {
      const required = requiredFlagsByType[type];

      selectedSkillsByType[type].forEach((skill:any) => {
        skills.push({
          skillId: skill.id,
          pharmacistType: skill.pharmacistType,
          required,
          name: skill.name,
          type: skill.type,
        });
      });
    });
   
    const payload = {
      id: originalJobData.id,
      jobTitle,
      jobCategoryId:
        jobCategories.filter((category:any) => category.name === selectedJobCategory)
          .length > 0
          ? jobCategories.filter(
              (category:any) => category.name === selectedJobCategory,
            )[0].id
          : null,
      jobCategoryName: selectedJobCategory,
      comment: comments,
      allowOtherProvince,
      estHourlyRate: (Number(wage) * 100),
      estStartDate: moment(dateObject.estStartDate),
      estEndDate: moment(dateObject.estEndDate),
      skills: skills,
      pharmacistType: workerType,
    };

    try {
      const updatedJob =  await PharmacyService.updateJob(payload);
      setIsLoading(false);

      setCreateShiftSubmitInfo({
        title: "Job Updated",
        message: "Your job has been updated.",
        buttons: [

          <RBButton
            buttonBackgroundColor={primaryColor}
            key={"Discard"}
            onClick={() => {
              setIsCreateShiftSubmitInfo(false)
              history.push("/Job/list")
            }}
            color="primary"
            text="Ok"
          />,
        ],
      })
      setIsCreateShiftSubmitInfo(true)
    } catch (err) {
    //   const errorMessage = err.response ? err.response.data.message : err.message;
    //   setSubmitErrorMessage(errorMessage);
    //   console.log("update shift on submit err", JSON.stringify(err, null, 2));

    if (err && err.response && err.response.data) {
        const unprocessableError = err.response.data;

        if (
          unprocessableError.error?.includes(
            'There are requests for this job already',
          )
        ) {

            setCreateShiftSubmitInfo({
                title: "Unable to update Job",
                message: "There are requests for this job already. You can not edit this job anymore.",
                buttons: [
        
                  <RBButton
                    buttonBackgroundColor={primaryColor}
                    key={"Discard"}
                    onClick={() => {
                      setIsCreateShiftSubmitInfo(false)
                      history.push("/Job/list")
                    }}
                    color="primary"
                    text="Ok"
                  />,
                ],
              })
              setIsCreateShiftSubmitInfo(true)

        } else {

            setCreateShiftSubmitInfo({
                title: "Unable to update Job",
                message: "An error has occurred updating job, please try again later.",
                buttons: [
        
                  <RBButton
                    buttonBackgroundColor={primaryColor}
                    key={"Discard"}
                    onClick={() => {
                      setIsCreateShiftSubmitInfo(false)
                      history.push("/Job/list")
                    }}
                    color="primary"
                    text="Ok"
                  />,
                ],
              })
              setIsCreateShiftSubmitInfo(true)

        }
      } else {
        setCreateShiftSubmitInfo({
            title: "Unable to update Job",
            message: `${JSON.stringify(err, null, 2)}.`,
            buttons: [
    
              <RBButton
                buttonBackgroundColor={primaryColor}
                key={"Discard"}
                onClick={() => {
                  setIsCreateShiftSubmitInfo(false)
                  history.push("/Job/list")
                }}
                color="primary"
                text="Ok"
              />,
            ],
          })
          setIsCreateShiftSubmitInfo(true)

      }

    } finally {
      setIsLoading(false);
    }
  };
  const renderActions = () => {
    console.log("edit shift renderActions");
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "row",
        }}
      >
        <RBButton
          // onClick={() => {
          //   doAction(ShiftRelatedConstants.ShiftButtonText.CancelShift);
          // }}
          onClick={() => onUpdateJob()}
          isLoading={loading}
        //   disabled={!isFormValid()}
        disabled={!isEdited ||  originalJobData?.pharmacy?.approval?.approvalMode === ApprovalModeEnum.OnHold}
          text="Update Job"
          style={{
            flex: 1,
            padding: Spacing.large,
            marginLeft: Spacing.large,
            marginRight: Spacing.large,
          }}
          buttonBackgroundColor={primaryColor}
        />
      </div>
    );
  };
  const tomorrow = moment()
  .add(1, 'day')
  .toDate();
  return (
    <>
      <RBErrorAlert
        show={submitErrorMessage ? true : false}
        errorMessage={JSON.stringify(submitErrorMessage, null, 2)}
        onClose={() => {
          setSubmitErrorMessage({ submitErrorMessage: undefined });
        }}
      />
      <RBAlert
        show={isCreateShiftSubmitInfo}
        alertTitle={createShiftSubmitInfo.title}
        alertMessage={createShiftSubmitInfo.message}
        buttons={createShiftSubmitInfo.buttons}
      />
      {isPageLoading ? (
        <LoadingIndicator />
      ) : (
        <>
          <RBCardView style={{ margin: Spacing.large, padding: Spacing.large }}>
            {renderPharmacyName()}
            {renderTitle()}
            {renderJobType()}
            {renderJobTime()}
            {renderWorkerType()}
            <div style={{ marginTop: Spacing.small }}>{renderShiftSkills()}</div>
            {renderPharmacySpecific()}
            {renderWage()}
            {renderJobDesc()}
          </RBCardView>
          {renderActions()}
        </>
      )}
    </>
  );
};
